import * as React from 'react'
import BasicDrawer from '@/components/Organisms/BasicDrawer/BasicDrawer.component'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { createAllWorkflowRulesQueryOptions } from '@/services/workflowRules/workflowRules.options'
import { createStatusesByCustomerOptions, createTicketTypesByCustomerOptions } from '@/services/ticket/ticketType.options'
import { createCustomerFieldsQueryOptions } from '@/services/ticket/ticket.options'
import WorkflowRuleDrawer2 from '@/pages/workflowRulesAdmin/workflowRulesDrawer/WorkflowRuleDrawer2.component'
import { createWorkflowAgentByCustomerQuery } from '@/services/agent/agent.options'

export const Route = createFileRoute('/_auth/workflow-rules/$workflowruleId')({
  component: () => <WorkflowRuleDrawer2 />,
  params: {
    parse: (params) => ({
      workflowruleId: z.number().int().parse(Number(params.workflowruleId)),
    }),
    stringify: ({ workflowruleId }) => ({ workflowruleId: `${workflowruleId}` }),
  },
  validateSearch: (search) => {
    return z
      .object({
        variant: z.enum(['edit', 'new']).default('edit'),
        step: z.number().min(0).max(3).default(0), // Based on your steps array length
        // completed: z.record(z.string(), z.boolean()).default({}),
        // showSecondaryContact: z.boolean().default(false)
      })
      .parse(search)
  },
  loader: async ({ params, context }) => {
    const options = createAllWorkflowRulesQueryOptions();
    const workflowRule = await context.queryClient.getQueryData(options.queryKey);
    const currentWorkflowRule = workflowRule?.oldSmartRules?.find(
      (rule: any) => rule.SmartRuleId === params.workflowruleId
    ) || workflowRule?.newSmartRules?.find(
      (rule: any) => rule.SmartRuleId === params.workflowruleId
    );
    const customerId = currentWorkflowRule?.Customer

    if (!customerId) {
      // throw new Error('Customer ID not found');
      return
    } else {
      await Promise.all([
        // context.queryClient.ensureQueryData(createWorkflowRuleQueryOptions({ srid: params.workflowruleId })),
        context.queryClient.ensureQueryData(createTicketTypesByCustomerOptions({ customerId })),
        context.queryClient.ensureQueryData(createStatusesByCustomerOptions({ customerId })),
        context.queryClient.ensureQueryData(createWorkflowAgentByCustomerQuery({ customerId })),
        context.queryClient.ensureQueryData(createCustomerFieldsQueryOptions(customerId))
      ])
    }
  }
})